import React from 'react'
import { getRatios } from 'api/urls';
import { getQueryParams } from 'utils/Utils';
import { useHistory } from 'react-router-dom';
import RatiosTableContainer from 'components/wrapper/RatiosTableContainer';

const RatiosTable = (props) => {
    const history = useHistory()
    const querryParams = getQueryParams(history.location.search)
    const unWantedKeys = ['as_on_date', 'created_at', 'updated_at', 'company_id', 'period', 'data_type', 'id', 'company']

    return (
        <div  {...props}>
            <RatiosTableContainer
                url={getRatios(querryParams.company__symbol)}
                title={"Ratios"}
                unWantedKeys={unWantedKeys}
            />
        </div>
    )
}

export default (RatiosTable);